import RestService from "@/services/RestService";
import evaluationTypeEnum from "@/enums/evaluationTypeEnum";
function getCurrentLessonItems(lessonId) {
  const data = {};
  return RestService.sendReq("get", `lesson/${lessonId}`, data);
}

function submitTest(evaluations) {
  const batchSendQuery = [];
  const fileSendQuery = [];
  evaluations.forEach((evaluation) => {
    const query = _evaluationQueryBuilder(evaluation);
    if (query instanceof FormData) {
      fileSendQuery.push(query);
    } else {
      batchSendQuery.push(query);
    }
  });
  const promise = RestService.sendReq("post", `evaluations`, batchSendQuery);
  const promises = fileSendQuery.map((query) =>
    RestService.sendReq("post", `evaluations`, query)
  );
  promises.push(promise);
  return Promise.all(promises);
}

function _quizQueryBuilder(evaluation) {
  let test_result = null;
  let text_result = null;
  switch (evaluation.type) {
    case evaluationTypeEnum.QUIZ:
    case evaluationTypeEnum.SELECT_ANSWER:
      test_result = evaluation.answer.index + 1;
      break;
    case evaluationTypeEnum.TASK:
      text_result = evaluation.answer;
      break;
      break;
  }
  return {
    evaluation: evaluation.id,
    text_result,
    test_result,
    status: 0,
    need_reevaluation: false,
    teacher_evaluation: 0,
  };
}

function _fileQueryBuilder(evaluation) {
  const formData = new FormData();
  evaluation.answer.forEach((file, i) => {
    formData.append(`files_result_${i}`, file);
  });
  formData.append("evaluation", evaluation.id);
  return formData;
}

function _evaluationQueryBuilder(evaluation) {
  switch (evaluation.type) {
    case evaluationTypeEnum.ADD_FILE:
      return _fileQueryBuilder(evaluation);
    default:
      return _quizQueryBuilder(evaluation);
  }
}

function submitOneTest(evaluation) {
  const data = _evaluationQueryBuilder(evaluation);
  return RestService.sendReq("post", `evaluations`, data);
}

function changeLessonStatus(lessonId) {
  const data = {};
  return RestService.sendReq("post", `finish_lesson/${lessonId}`, data);
}

export default {
  getCurrentLessonItems,
  submitTest,
  submitOneTest,
  changeLessonStatus,
};
